import { NotificationSilentMessage } from '@/service/api/endpoints/notificacoes'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type StoredNotification = {
    value: number
    module: string
    type: string
    ref: string
    id: string
}

type Store = {
    content: StoredNotification[]
    update: (value: NotificationSilentMessage) => void
}

export const useNotificacoesSilentStore = create<Store>()(
    persist(
        (set, get) => ({
            content: [],
            update: (value: NotificationSilentMessage) => {
                const current = get().content
                if (typeof value.body !== 'object' || value.body === null)
                    return

                const body = value.body as {
                    value?: number | string
                    ref?: string
                    id?: string
                }

                const numericValue = Number(body.value)
                if (!Number.isFinite(numericValue)) return

                const ref = body.ref ?? value.type
                const id = body.id ?? value.id
                if (!ref || !id) return

                const transformed = {
                    value: numericValue,
                    module: value.module,
                    type: value.type,
                    ref,
                    id,
                } satisfies StoredNotification

                const exists = current.find(
                    n =>
                        transformed.module === n.module &&
                        transformed.type === n.type &&
                        transformed.ref === n.ref &&
                        transformed.id === n.id,
                )

                const shouldRemove = transformed.value >= 100
                if (shouldRemove) {
                    set({
                        content: current.filter(
                            n =>
                                !(
                                    transformed.module === n.module &&
                                    transformed.type === n.type &&
                                    transformed.ref === n.ref &&
                                    transformed.id === n.id
                                ),
                        ),
                    })
                    return
                }
                if (exists) {
                    set({
                        content: current.map(n =>
                            n.module === transformed.module &&
                            n.type === transformed.type &&
                            n.ref === transformed.ref &&
                            n.id === transformed.id
                                ? { ...n, value: transformed.value }
                                : n,
                        ),
                    })
                } else {
                    set({ content: [...current, transformed] })
                }
            },
        }),
        {
            name: 'notificacoes-silent-store',
            version: 1,
        },
    ),
)
